import React from 'react';

import { defaultColumns } from "../../Modules/Bookings/Components/Table/BookingsListColumns";

const TableHeader = (props) => {

    const columns = props.columnData ?? {...defaultColumns}

    return (
        <thead>
            <tr>
                { Object
                    .keys(columns)
                    .map(key =>
                        <th key={key}
                            className={`column-${columns[key].key} ${columns[key].className ?? ''}`}
                        >
                            {columns[key].name}
                        </th>
                    )
                }
            </tr>
        </thead>
    );
}

export default TableHeader;


